{
  "claude-3-opus-20240229": {
    "modelName": "claude-3-opus-20240229",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 15,
            "outputPricePerMillion": 75
          }
        }
      }
    ]
  },
  "claude-3-sonnet-20240229": {
    "modelName": "claude-3-sonnet-20240229",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 3,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "claude-3-5-sonnet-20240620": {
    "modelName": "claude-3-5-sonnet-20240620",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 3,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "claude-3-5-sonnet-20241022": {
    "modelName": "claude-3-5-sonnet-20241022",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 3,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "claude-3-7-sonnet-20250219": {
    "modelName": "claude-3-7-sonnet-20250219",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 3,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "claude-3-haiku-20240307": {
    "modelName": "claude-3-haiku-20240307",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.25,
            "outputPricePerMillion": 1.25
          }
        }
      }
    ]
  },
  "claude-3-haiku-20241022": {
    "modelName": "claude-3-haiku-20241022",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.25,
            "outputPricePerMillion": 1.25
          }
        }
      }
    ]
  },
  "claude-3-5-haiku-20241022": {
    "modelName": "claude-3-5-haiku-20241022",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.8,
            "outputPricePerMillion": 4
          }
        }
      }
    ]
  },
  "claude-4-sonnet-20250514": {
    "modelName": "claude-4-sonnet-20250514",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 3,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "claude-4-opus-20250514": {
    "modelName": "claude-4-opus-20250514",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 15,
            "outputPricePerMillion": 75
          }
        }
      }
    ]
  },
  "claude-sonnet-4-5-20250929": {
    "modelName": "claude-sonnet-4-5-20250929",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 3,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "claude-sonnet-4-6": {
    "modelName": "claude-sonnet-4-6",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 3,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "claude-haiku-4-5-20251001": {
    "modelName": "claude-haiku-4-5-20251001",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1,
            "outputPricePerMillion": 5
          }
        }
      }
    ]
  },
  "claude-opus-4-5-20251101": {
    "modelName": "claude-opus-4-5-20251101",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 25
          }
        }
      }
    ]
  },
  "claude-opus-4-6": {
    "modelName": "claude-opus-4-6",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 25
          }
        }
      }
    ]
  },
  "claude-opus-4-7": {
    "modelName": "claude-opus-4-7",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 25
          }
        }
      }
    ]
  }
}
